import React from "react";
import { useState } from "react";
import * as sweetalert from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FormInput from "./FormInput";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const Forminput = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    first_name: "",
    last_name: "",
    father_name: "",
    mother_name: "",
    mobile_number: "",
    id_number: "",
    password: "",
    password_confirmation: "",
    personal_photo: "",
    id_photo1: "",
    id_photo2: "",
    city_id: "",
    zone_id: "",
  });

  const inputs = [
    {
      id: 1,
      name: "first_name",
      type: "text",
      placeholder: "الرجاء ادخال الاسم الأول",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
      label: "اسم المستخدم",
      pattern: "^[A-Za-z0-9]{3,16}$",
      required: true,
    },
    {
      id: 2,
      name: "last_name",
      type: "text",
      placeholder: "الرجاء ادخالا الاسم الاخير",
      errorMessage: "الرجاء ادخال الاسم الاخير",
      label: "الكنية",
      required: true,
    },
    {
      id: 3,
      name: "father_name",
      type: "text",
      placeholder: "الرجاء ادخال اسم الأب",
      label: "اسم الأب",
      errorMessage: "الرجاء أدخال اسم الاب",
    },
    {
      id: 4,
      name: "mother_name",
      type: "text",
      placeholder: "الرجاء ادخال اسم الأم",
      errorMessage: "الرجاء ادخال اسم الام",
      label: "اسم الأم",
      required: true,
    },
    {
      id: 5,
      name: "mobile_number",
      type: "number",
      placeholder: "الرجاء ادخال رقم الهاتف",
      label: "رقم الموبايل",
      errorMessage: "الرجاء أدخال  رقم الهاتف",
      required: true,
    },
    {
      id: 6,
      name: "id_number",
      type: "number",
      placeholder: "الرجاء ادخال الرقم الوطني",
      errorMessage: "الرجاء ادخال الرقم الوطني",
      label: "الرقم الوطني",

      required: true,
    },
    {
      id: 7,
      name: "password",
      type: "password",
      placeholder: "الرجاء ادخال كلمة السر",
      label: "كلمة السر",
      required: true,
      errorMessage:
        "Password should be 8-20 characters and include at least 1 letter, 1 number and 1 special character!",

      pattern: `^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$`,
    },
    {
      id: 8,
      name: "password_confirmation",
      placeholder: "الرجاء تأكيد كلمة السر",
      type: "password",
      errorMessage: "Passwords don't match!",
      label: "تأكيد كلمة السر",
      pattern: values.password,
      required: true,
    },
    {
      id: 9,
      name: "id_photo1",
      placeholder: "الرجاء ادخال صورة الهوية الوجه الأول",
      type: "file",
      label: "صورة الهوية 1",
      errorMessage: "Passwords don't match!",
      required: true,
    },
    {
      id: 10,
      name: "id_photo2",
      placeholder: "الرجاء ادخال صورة الهوية الوجه الأول",
      type: "file",
      label: "صورة الهوية 2",
      errorMessage: "Passwords don't match!",
      required: true,
    },
    {
      id: 11,
      name: "personal_photo",
      type: "file",
      label: "صور ",
      errorMessage: "Passwords don't match!",
      required: true,
    },
    {
      id: 12,
      name: "city_id",
      type: "text",
      label: "صور ",
      errorMessage: "Passwords don't match!",
      required: true,
      value: "3",
    },
    {
      id: 13,
      name: "zone_id",
      type: "text",
      label: "صور ",
      errorMessage: "Passwords don't match!",
      required: true,
      value: "1",
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    const bodyFormData = new FormData();
    bodyFormData.append("first_name", values.first_name);
    bodyFormData.append("last_name", values.last_name);
    bodyFormData.append("father_name", values.father_name);
    bodyFormData.append("mother_name", values.mother_name);
    bodyFormData.append("mobile_number", values.mobile_number);
    bodyFormData.append("id_number", values.id_number);
    bodyFormData.append("password", values.password);
    bodyFormData.append("password_confirmation", values.password_confirmation);
    bodyFormData.append("staff_type", "Client");
    bodyFormData.append("personal_photo", values.personal_photo);
    bodyFormData.append("id_photo1", values.id_photo1);
    bodyFormData.append("id_photo2", values.id_photo2);
    bodyFormData.append("city_id", values.city_id);
    bodyFormData.append("zone_id", values.zone_id);
    e.preventDefault();
    axios
      .post(
        `${BaseUrl}/api/staff`,
        bodyFormData,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.status === true) {
          sweetalert("تم إضافة مستخدم بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });

          navigate("/staff");
        } else {
          sweetalert("error", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        }
      });
  };

  const onChange = (e) => {
    if (e.target.type == "file") {
      setValues({ ...values, [e.target.name]: e.target.files[0] });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  return (
    <div className="app">
      <form onSubmit={handleSubmit}>
        <h1>Register</h1>
        {inputs.map((input) => (
          <FormInput
            key={input.id}
            {...input}
            value={values[inputs]}
            onChange={onChange}
          />
        ))}
        <button>Submit</button>
      </form>
    </div>
  );
};

export default Forminput;
